import React from 'react'
import LegacyDocument from './FinancialDocument'
import DocumentRenewed from './document-renewed'
import DocumentBucketModal from './modals/DocumentBucketModal'
import Modal from '../common/Modal'
import Divider from './document-renewed/divider'
import DocumentFormModal from './document-renewed/document-form-modal'

import {
  Container,
  Header,
  TitleContainer,
  ButtonContainer,
  Caret,
  GreyButton,
  DocInfo,
  DocumentsContainer as LegacyDocumentsContainer,
  DocumentsContainerRenewed,
  DocumentRenewedWrapper
} from './styles/CategoryStyles'

const DocumentsContainer = __updated_documents_experience_ui
  ? DocumentsContainerRenewed
  : LegacyDocumentsContainer

const Document = __updated_documents_experience_ui
  ? (props) => (
      <DocumentRenewedWrapper>
        <DocumentRenewed {...props} />
      </DocumentRenewedWrapper>
    )
  : LegacyDocument 


export default class Category extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      isDocumentBucketModalOpen: false
    }
  }
  get allDocuments() {
    const { documents = [] } = this.props

    return documents
  }
  get totalDocs() {
    const { allDocuments } = this

    return allDocuments.length
  }
  componentWillMount() {
    const { props: { handedOff }, allDocuments } = this
    const hasUploadNotifications = allDocuments.filter(({ hasUploadNotifications }) => hasUploadNotifications).length > 0
    const isOpen = handedOff || hasUploadNotifications

    if (isOpen) {
      this.toggleOpen()
    }
  }
  toggleOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }
  toggleDocumentBucketModal = () => {
    this.setState({
      isDocumentBucketModalOpen: !this.state.isDocumentBucketModalOpen
    })
  }
  isAffiliate = () => {
    const { entityId, affiliateIds = [] } = this.props

    return affiliateIds.some(id => id === entityId);
  }
  onDocumentButtonClick = e => {
    e.preventDefault()
    e.stopPropagation()
    this.toggleDocumentBucketModal()
  }
  orderedDocs = () => {
    const { allDocuments } = this

    return allDocuments.slice().sort(({ title: aTitle }, { title: bTitle }) => aTitle.localeCompare(bTitle))
  }
  uploadedDocs = () => {
    const { allDocuments } = this

    return allDocuments.filter(({ files }) => files.length > 0).length
  }
  renderDocuments = () => {
    const { state: { isOpen }, orderedDocs } = this
    const {
      entityId,
      categories,
      loanId,
      guarantors,
      resourceType,
      superUser,
      canComment,
      bankAdmin,
      customerService,
      disabled,
      idx,
      category,
      affiliateIds,
      entity,
      resetClientStore,
      isArchived
    } = this.props

    if (isOpen) {
      //Alphabetically sort document buckets
      return orderedDocs().map((doc, index) => (
        <React.Fragment key={doc.rid}>
          {__updated_documents_experience_ui && index > 0 && <Divider density={2} />}
          <Document
            key={`${doc.title}-${doc.rid}`}
            document={doc}
            entityId={entityId}
            categories={categories}
            category={category}
            guarantors={guarantors}
            loanId={loanId}
            resourceType={resourceType}
            superUser={superUser}
            canComment={canComment}
            bankAdmin={bankAdmin}
            customerService={customerService}
            disabled={disabled}
            idx={idx}
            entity={entity}
            isAffiliate={this.isAffiliate()}
            affiliateIds={affiliateIds}
            resetClientStore={resetClientStore}
            isArchived={isArchived}
          />
        </React.Fragment>
        ))
    }
  }
  renderDocumentButton = () => {
    const {
      props: { disabled },
      state: { isOpen },
      totalDocs,
      uploadedDocs
    } = this

    if (isOpen && !disabled) {
      return (
        <ButtonContainer>
          <GreyButton id="new_document_bucket_button" onClick={this.onDocumentButtonClick}>
            New document bucket
          </GreyButton>
        </ButtonContainer>
      )
    } else if (!isOpen && !disabled) {
      return (
        <DocInfo>
          {uploadedDocs()} OF {totalDocs} UPLOADED
        </DocInfo>
      )
    } else {
      return (
        <DocInfo>
          {totalDocs}
        </DocInfo>
      )
    }
  }
  renderDocumentBucketModal = () => {
    const {
      state : {
        isDocumentBucketModalOpen
      },
      props: {
        categories,
        entityId,
        loanId,
        guarantors,
        resourceType,
        category,
        affiliateIds,
        resetClientStore,
        entity
      }
    } = this

    if (!__updated_documents_experience_ui)
      return (
        <Modal
          light
          isModalOpen={isDocumentBucketModalOpen}
        >
          <DocumentBucketModal
            resetClientStore={resetClientStore}
            categories={categories}
            toggleModal={this.toggleDocumentBucketModal}
            entityId={entityId}
            document={{}} // Pass an empty object to trigger defaults
            loanId={loanId}
            resourceType={resourceType}
            guarantors={guarantors}
            category={category}
            isAffiliate={this.isAffiliate()}
            affiliateIds={affiliateIds}
            entity={entity}
            newBucket
          />
        </Modal>
      )

    if (isDocumentBucketModalOpen)
      return (
        <DocumentFormModal
          loanId={loanId}
          guarantors={guarantors}
          onClose={this.toggleDocumentBucketModal}
          creatingAttrs={{ baseEntity: entity, baseCategory: category }}
        />
      )
   
    return null
  }
  render() {
    const { props: { title, id }, totalDocs } = this
    const { isOpen } = this.state

    return (
      <>
        { totalDocs > 0 && <Container id={id}>
            <Header id="category_header" onClick={this.toggleOpen}>
              <TitleContainer id="category_title">
                { isOpen ? <Caret className="fa fa-caret-down" open /> : <Caret className="fa fa-caret-right" />}
                &nbsp;
                {title}
              </TitleContainer>
              {this.renderDocumentButton()}
            </Header>
            <DocumentsContainer isOpen={isOpen}>
              {this.renderDocuments()}
            </DocumentsContainer>
            {this.renderDocumentBucketModal()}
          </Container>
        }
      </>
    )
  }
}
